<template>
  <div>
    <v-container fluid>

      <v-overlay :value="overlay" opacity="0">
        <v-progress-circular
            color="primary"
            indeterminate
            size="50"
        ></v-progress-circular>
      </v-overlay>

      <v-row v-if="isLoading">
        <v-col cols="12" lg="3" v-for="item in 4" :key="item">
          <v-card class="rounded-lg shadow">
            <v-card-text>
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-else>

        <v-col cols="12" lg="3">
          <v-card class="rounded-lg shadow">
            <v-card-title class="pb-0 text-no-wrap">
              <span class="fs-15">
                  Scan aujourd'hui
              </span>
              <v-spacer/>
              <v-avatar color="indigo" size="38">
                <v-icon dark>mdi-calendar-today</v-icon>
              </v-avatar>
            </v-card-title>
            <v-card-text>
              <h4 class="mb-2 indigo--text">
                Pos : {{ widgets.pos.today.used }}
                <small class="indigo--text text--lighten-1">
                  / {{ widgets.pos.today.winning_points | toCurrency }} pts
                </small>
              </h4>
              <h4 class="mb-2 indigo--text">
                Duo : {{ widgets.user.today.used }}
                <small class="indigo--text text--lighten-1">
                  / {{ widgets.user.today.winning_points | toCurrency }} pts
                </small>
              </h4>
              <h3 class="mb-2 indigo--text">
                Total : {{ widgets.pos.today.used + widgets.user.today.used }}
                <small class="indigo--text text--lighten-1">
                  / {{
                    (Number(widgets.pos.today.winning_points) + Number(widgets.user.today.winning_points)) | toCurrency
                  }} pts
                </small>
              </h3>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" lg="3">
          <v-card class="rounded-lg shadow">
            <v-card-title class="pb-0 text-no-wrap">
      <span class="fs-15">
      Scan cette semaine
      </span>
              <v-spacer/>
              <v-avatar color="blue" size="38">
                <v-icon dark>mdi-calendar-week</v-icon>
              </v-avatar>
            </v-card-title>
            <v-card-text>
              <h4 class="mb-2 blue--text">
                Pos : {{ widgets.pos.week.used }}
                <small class="blue--text text--lighten-1">
                  / {{ widgets.pos.week.winning_points | toCurrency }} pts
                </small>
              </h4>
              <h4 class="mb-2 blue--text">
                Duo : {{ widgets.user.week.used }}
                <small class="blue--text text--lighten-1">
                  / {{ widgets.user.week.winning_points | toCurrency }} pts
                </small>
              </h4>
              <h3 class="mb-2 blue--text">
                Total : {{ widgets.pos.week.used + widgets.user.week.used }}
                <small class="blue--text text--lighten-1">
                  / {{ (+widgets.pos.week.winning_points + +widgets.user.week.winning_points) | toCurrency }} pts
                </small>
              </h3>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" lg="3">
          <v-card class="rounded-lg shadow">
            <v-card-title class="pb-0 text-no-wrap">
      <span class="fs-15">
        Scan ce mois
      </span>
              <v-spacer/>
              <v-avatar color="green" size="38">
                <v-icon dark>mdi-calendar-month</v-icon>
              </v-avatar>
            </v-card-title>
            <v-card-text>
              <h4 class="mb-2 green--text">
                Pos : {{ widgets.pos.month.used }}
                <small class="green--text text--lighten-1">
                  / {{ widgets.pos.month.winning_points | toCurrency }} pts
                </small>
              </h4>
              <h4 class="mb-2 green--text">
                Duo : {{ widgets.user.month.used }}
                <small class="green--text text--lighten-1">
                  / {{ widgets.user.month.winning_points | toCurrency }} pts
                </small>
              </h4>
              <h3 class="mb-2 green--text">
                Total : {{ widgets.pos.month.used + widgets.user.month.used }}
                <small class="green--text text--lighten-1">
                  / {{ (+widgets.pos.month.winning_points + +widgets.user.month.winning_points) | toCurrency }} pts
                </small>
              </h3>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" lg="3">
          <v-card class="rounded-lg shadow">
            <v-card-title class="pb-0 text-no-wrap">
      <span class="fs-15">
      Total des scans
      </span>
              <v-spacer/>
              <v-avatar color="teal" size="38">
                <v-icon dark>mdi-chart-bar</v-icon>
              </v-avatar>
            </v-card-title>
            <v-card-text>
              <h4 class="mb-2 teal--text">
                Pos : {{ widgets.pos.all.used }}
                <small class="teal--text text--lighten-1">
                  / {{ widgets.pos.all.winning_points | toCurrency }} pts
                </small>
              </h4>
              <h4 class="mb-2 teal--text">
                Duo : {{ widgets.user.all.used }}
                <small class="teal--text text--lighten-1">
                  / {{ widgets.user.all.winning_points | toCurrency }} pts
                </small>
              </h4>
              <h3 class="mb-2 teal--text">
                Total : {{ widgets.pos.all.used + widgets.user.all.used }}
                <small class="teal--text text--lighten-1">
                  / {{ (+widgets.pos.all.winning_points + +widgets.user.all.winning_points) | toCurrency }} pts
                </small>
              </h3>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" lg="3">
          <v-card class="rounded-lg shadow">
            <v-card-title class="d-flex align-center pb-0">
              <span class="fs-17 font-weight-medium">
                {{ widgets.enrollment_rate?.percentage }}
              </span>
              <v-spacer/>
              <v-avatar color="deep-purple" size="38">
                <v-icon dark>mdi-chart-donut</v-icon>
              </v-avatar>
            </v-card-title>
            <v-card-text>
              <h4 class="deep-purple--text mb-2">
                Total : {{ widgets.enrollment_rate?.total_usages }}
              </h4>
              <h4 class="deep-purple--text mb-2">
                Par compte Gifty : {{ widgets.enrollment_rate?.unique_participants }}
              </h4>
              Taux d'enrôlement/participation
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" lg="3">
          <v-card class="rounded-lg shadow">
            <v-card-title class="d-flex align-center">
              <span class="fs-17 font-weight-medium">{{ widgets.products_played_per_week }}</span>
              <v-spacer/>
              <v-avatar color="blue" size="38">
                <v-icon dark>mdi-cube-outline</v-icon>
              </v-avatar>
            </v-card-title>
            <v-card-text>
              Nombre de produit joué par compte Gifty par semaine
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" lg="3">
          <v-card class="rounded-lg shadow">
            <v-card-title class="d-flex align-center">
              <span class="fs-17 font-weight-medium">{{ widgets.weekly_play_frequency }}</span>
              <v-spacer/>
              <v-avatar color="green" size="38">
                <v-icon dark>mdi-calendar-clock</v-icon>
              </v-avatar>
            </v-card-title>
            <v-card-text>
              Fréquence de jeu par semaine par compte Gifty
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" lg="3">
          <v-card class="rounded-lg shadow">
            <v-card-title class="d-flex align-center">
              <span class="fs-15">
                Pos
              </span>

              <v-spacer/>
              <v-avatar color="warning" size="38">
                <v-icon dark>mdi-store</v-icon>
              </v-avatar>
            </v-card-title>
            <v-card-text>
              <h4 class="mb-2 warning--text">
                Nombre unique :
                <span class="warning--text text--lighten-1">
                 {{ widgets.pos.unique_count }}
               </span>
              </h4>
              <h4 class="mb-2 warning--text">
                Nombre recurrent :
                <span class="warning--text text--lighten-1">
                  {{ widgets.pos.recurring_count }}
               </span>
              </h4>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" lg="3">
          <v-card class="rounded-lg shadow">
            <v-card-title class="d-flex align-center">
                <span class="fs-15">
                 Acheteur
                </span>
              <v-spacer/>
              <v-avatar color="pink" size="38">
                <v-icon dark>mdi-account-group</v-icon>
              </v-avatar>
            </v-card-title>
            <v-card-text>
              <h4 class="mb-2 pink--text">
                Nombre unique :
                <span class="pink--text text--lighten-1">
                  {{ widgets.user.unique_count }}
               </span>
              </h4>
              <h4 class="mb-2 pink--text">
                Nombre recurrent :
                <span class="pink--text text--lighten-1">
                   {{ widgets.user.recurring_count }}
               </span>
              </h4>
            </v-card-text>
          </v-card>
        </v-col>


      </v-row>


      <v-row v-if="isLoading4">
        <v-col cols="12">
          <v-card class="rounded-lg shadow">
            <v-card-text>
              <v-skeleton-loader type="card"></v-skeleton-loader>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col cols="12">
          <v-card class="rounded-lg shadow">
            <v-card-title>
              Nombre de scan par région
            </v-card-title>
            <v-divider/>
            <v-card-text>
              <v-row>
                <v-col
                    v-for="(regionData, regionName) in regions_widgets"
                    :key="regionName"
                    cols="12"
                    lg="3"
                >
                  <v-card class="rounded-lg" outlined flat>
                    <v-card-title class="pb-0 text-no-wrap">
          <span class="fs-15">
            {{ regionName }}
          </span>
                      <v-spacer/>
                      <v-avatar color="info" size="38">
                        <v-icon dark>mdi-map-marker</v-icon>
                      </v-avatar>
                    </v-card-title>

                    <v-card-text>
                      <h4 class="mb-2 indigo--text">
                        Pos : {{ regionData.pos.used }}
                        <small class="indigo--text text--lighten-1">
                          / {{ regionData.pos.winning_amount | toCurrency }} pts
                        </small>
                      </h4>
                      <h4 class="mb-2 indigo--text">
                        Duo : {{ regionData.user.used }}
                        <small class="indigo--text text--lighten-1">
                          / {{ regionData.user.winning_amount | toCurrency }} pts
                        </small>
                      </h4>
                      <h3 class="mb-2 indigo--text">
                        Total : {{ regionData.pos.used + regionData.user.used }}
                        <small class="indigo--text text--lighten-1">
                          / {{
                            (Number(regionData.pos.winning_amount) + Number(regionData.user.winning_amount)) | toCurrency
                          }} pts
                        </small>
                      </h3>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="isLoading3">
        <v-col cols="12">
          <v-card class="rounded-lg shadow">
            <v-card-text>
              <v-skeleton-loader type="image"></v-skeleton-loader>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col cols="12">
          <v-card class="rounded-lg shadow">
            <v-card-title>
              Nombre de scan des 10 derniers jours
            </v-card-title>
            <v-divider/>
            <v-card-text>
              <MultipleBarChart id="chart"
                                title="Nombre de scan des 10 derniers jours"
                                :data="chartData.data"
                                :labels="chartData.labels"
                                :keys="chartData.keys"
                                class="chart-canvas"/>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs centered v-model="tab" color="primary" background-color="transparent">
            <v-tab tab-value="one" @click="getTopPos">Classement des PDV selon leur vente</v-tab>
            <v-tab tab-value="two" @click="getDaysUsage">Analyse des scans par jour</v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <div v-if="tab === 'one'">
        <v-row v-if="isLoading2">
          <v-col cols="12">
            <v-card class="rounded-lg shadow">
              <v-card-text>
                <v-skeleton-loader type="table"></v-skeleton-loader>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12">
            <v-card class="rounded-lg shadow">
              <v-card-title>
                Classement des PDV selon leur vente
                <v-spacer></v-spacer>

                <v-btn color="blue"
                       text
                       class="text-none mr-1"
                       @click="ExportExcel">
                  <v-icon left>mdi-download</v-icon>
                  Exporter
                </v-btn>

                <v-btn color="blue"
                       depressed
                       text
                       class="text-none">
                  <v-icon left>mdi-tune</v-icon>
                  Filtrer
                </v-btn>

                <v-btn color="blue"
                       depressed
                       text
                       @click="getTopPos"
                       class="text-none">
                  <v-icon left>mdi-refresh</v-icon>
                  Mettre à jour
                </v-btn>

              </v-card-title>
              <v-divider/>
              <v-card-text class="pa-0">
                <v-data-table hide-default-footer
                              :items-per-page="per_page"
                              :headers="headers"
                              :items="salepoints">

                  <template v-slot:item.total_usage="{item}">
                    <strong class="green--text">
                      <v-icon color="green" small>mdi-circle</v-icon>
                      {{ item.total_usage }}
                    </strong>
                  </template>

                  <template v-slot:item.total_users_winning_amount="{item}">
                    <strong class="purple--text">
                      <v-icon color="purple" small>mdi-circle</v-icon>
                      {{ item.total_users_winning_amount | toCurrency }}
                    </strong>
                  </template>

                  <template v-slot:item.total_salepoints_winning_amount="{item}">
                    <strong class="orange--text">
                      <v-icon color="orange" small>mdi-circle</v-icon>
                      {{ item.total_salepoints_winning_amount | toCurrency }}
                    </strong>
                  </template>

                </v-data-table>

              </v-card-text>

              <v-divider/>

              <v-card-actions>
                <div>
                  <v-select v-model="per_page"
                            :items="[10,20,50,100,200,300,400,500]"
                            :style="{width: '120px'}"
                            dense
                            hide-details
                            label="Ligne par page"
                            outlined></v-select>
                </div>

                <v-spacer/>
                <v-pagination v-model="pagination.current"
                              :length="pagination.total"
                              circle
                              total-visible="6"
                              @input="onPageChange"
                ></v-pagination>
              </v-card-actions>

            </v-card>
          </v-col>
        </v-row>
      </div>

      <div v-if="tab === 'two'">
        <v-row>
          <v-col cols="12">
            <v-card class="rounded-lg shadow">

              <v-card-title>
                <v-spacer/>
                <v-btn color="blue"
                       text
                       class="text-none"
                       @click="ExportTransactionsExcel">
                  <v-icon left>mdi-download</v-icon>
                  Exporter les transactions
                </v-btn>
              </v-card-title>

              <v-divider/>

              <v-card-text>
                <v-skeleton-loader v-if="isLoading5" type="table"></v-skeleton-loader>

                <v-simple-table v-else class="table-border rounded-lg">
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th>Date</th>
                      <th>Total Scans</th>
                      <th>Pos uniques</th>
                      <th>Scans Pos</th>
                      <th>Scans Duo</th>
                      <th>Nouveaux POS</th>
                      <th>Acheteurs uniques</th>
                      <th>Nouveaux acheteurs</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, i) in daily_usages" :key="i">

                      <td class="font-weight-bold info--text">{{ item.date }}</td>

                      <td class="font-weight-bold info--text">
                        {{ Number(item.posUsage) + Number(item.userUsage) }}
                      </td>

                      <td>{{ item.posCount }}</td>
                      <td>{{ item.posUsage }}</td>
                      <td>{{ item.userUsage }}</td>
                      <td>{{ item.newSalepoints }}</td>
                      <td>{{ item.userCount }}</td>
                      <td>{{ item.newUsers }}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>

              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import {HTTP} from "@/http-common";
import MultipleBarChart from "../../components/Chart/3MultipleBarChart";

export default {
  components: {
    MultipleBarChart
  },
  data() {
    return {
      url: 'https://api.gifty.opus.win',
      tab: 'one',
      overlay: false,
      isLoading: false,
      isLoading2: false,
      isLoading3: false,
      isLoading4: false,
      isLoading5: false,
      FILE_URL: process.env.VUE_APP_FILE_URL,
      widgets: {
        pos: {today: {}, week: {}, month: {}, all: {}},
        user: {today: {}, week: {}, month: {}, all: {}},
        enrollment_rate: null,
        products_played_per_week: null,
        weekly_play_frequency: null,
      },

      regions_widgets: {},
      daily_usages: [],
      chartData: {},

      keyword: null,
      filter: {},
      salepoints: [],
      total: 0,
      per_page: 10,
      pagination: {
        current: 1,
        total: 0
      },

      headers: [
        {text: 'Nom', value: 'salepoint_account.salepoint.name'},
        {text: 'Code', value: 'salepoint_account.salepoint_code'},
        {text: 'Type', value: 'salepoint_account.salepoint.type'},
        {text: 'Région', value: 'salepoint_account.salepoint.region'},
        {text: 'Commune', value: 'salepoint_account.salepoint.municipality'},
        {text: 'Téléphone', value: 'salepoint_account.salepoint.phone'},
        {text: 'Nombre de scan', value: 'total_usage'},
        {text: 'P.gagnés - Acheteur    ', value: 'total_users_winning_amount'},
        {text: 'P.gagnés - POS', value: 'total_salepoints_winning_amount'},
      ],
    }
  },
  methods: {
    getWidgets() {
      this.isLoading = true
      axios.get(this.url + "/api/tip/widgets").then(res => {
        this.widgets = res.data.data
        this.isLoading = false
      }).catch((err) => {
        console.log(err)
        this.isLoading = false
      })
    },
    getWidgetsByRegions() {
      this.isLoading4 = true
      HTTP.get("/boosting-dashboard/widgets-by-regions").then(res => {
        this.regions_widgets = res.data.data
        this.isLoading4 = false
      }).catch((err) => {
        console.log(err)
        this.isLoading4 = false
      })
    },
    getLast10DaysUsage() {
      this.isLoading3 = true
      axios.get(this.url + "/api/tip/usage-stats/last-10-days").then(res => {
        this.chartData = res.data.data
        this.isLoading3 = false
      }).catch((err) => {
        console.log(err)
        this.isLoading3 = false
      })
    },
    getDaysUsage() {
      this.isLoading5 = true
      axios.get(this.url + "/api/tip/usage-stats/daily-usage").then(res => {
        this.daily_usages = res.data.data
        this.isLoading5 = false
      }).catch((err) => {
        console.log(err)
        this.isLoading5 = false
      })
    },
    onPageChange() {
      this.getTopPos();
    },
    getTopPos() {
      this.isLoading2 = true
      this.$Progress.start()
      HTTP.get("/boosting-dashboard/top-pos", {
        params: {
          filter: this.filter,
          page: this.pagination.current,
          per_page: this.per_page,
          keyword: this.keyword,
        }
      }).then(res => {
        this.salepoints = res.data.data.data
        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
        this.total = res.data.data.total;
        this.isLoading2 = false
        this.$Progress.finish()
      }).catch((err) => {
        console.log(err)
        this.isLoading2 = false
        this.$Progress.fail()
      })
    },
    ExportExcel() {
      let baseUrl = process.env.VUE_APP_FILE_URL
      let token = this.$store.state.user.token
      let userId = this.$store.state.user.id
      let DownloadURL = baseUrl + '/export/excel/boosting?token=' + token + '&id=' + userId;
      window.open(DownloadURL, '_blanc')
    },
    ExportTransactionsExcel() {
      let baseUrl = process.env.VUE_APP_FILE_URL
      let token = this.$store.state.user.token
      let userId = this.$store.state.user.id
      let DownloadURL = baseUrl + '/export/excel/boosting-transactions?token=' + token + '&id=' + userId;
      window.open(DownloadURL, '_blanc')
    },
  },
  created() {
    this.getWidgets()
    this.getWidgetsByRegions()
    this.getTopPos()
    this.getLast10DaysUsage()
  },
  watch: {
    keyword() {
      this.getTopPos();
    },
    per_page() {
      this.pagination.current = 1
      this.getTopPos();
    },
  },
}
</script>

<style>
.chart-canvas {
  height: 400px;
}

.chart-canvas canvas {
  height: 100% !important;
}
</style>